import { type ColumnsState, createColumnsHook } from './createColumnsHook';

export const PERCENTAGE_CHECK_COLUMNS = [
  'unit',
  'contractType',
  'contractStatus',
  'maxPercentage',
  'minPercentage',
  'avgPercentage',
  'daysBelow',
  'daysAt100',
  'daysAbove',
  'classification',
] as const;

export type PercentageCheckColumn = (typeof PERCENTAGE_CHECK_COLUMNS)[number];

export const PERCENTAGE_CHECK_DEFAULT_COLUMNS: readonly PercentageCheckColumn[] = [
  'unit',
  'contractType',
  'maxPercentage',
  'minPercentage',
  'daysBelow',
  'daysAbove',
  'classification',
];

export const PERCENTAGE_CHECK_COLUMN_LABEL_KEYS = {
  unit: 'consultas.conferenciaPercentual.colunas.unidade',
  contractType: 'consultas.conferenciaPercentual.colunas.tipoContrato',
  contractStatus: 'consultas.conferenciaPercentual.colunas.situacaoContrato',
  maxPercentage: 'consultas.conferenciaPercentual.colunas.maximo',
  minPercentage: 'consultas.conferenciaPercentual.colunas.minimo',
  avgPercentage: 'consultas.conferenciaPercentual.colunas.media',
  daysBelow: 'consultas.conferenciaPercentual.colunas.diasAbaixo',
  daysAt100: 'consultas.conferenciaPercentual.colunas.diasEm100',
  daysAbove: 'consultas.conferenciaPercentual.colunas.diasAcima',
  classification: 'consultas.conferenciaPercentual.colunas.classificacao',
} as const satisfies Record<PercentageCheckColumn, string>;

export const usePercentageCheckColumns = createColumnsHook({
  columns: PERCENTAGE_CHECK_COLUMNS,
  defaultColumns: PERCENTAGE_CHECK_DEFAULT_COLUMNS,
  storageKey: 'percentage-check-table-columns',
  version: 1,
});

export type PercentageCheckColumnsState = ColumnsState<PercentageCheckColumn>;
